<!-- O menu só tem a tributação em lote: some inteiro quando ela está oculta (ação 3) -->
<button *appSePermitido="funcionalidadeId" mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <button *ngIf="showNfceConfig" mat-menu-item (click)="openModal()">
    <div >
      <span>Definir Regra de Tributação IBS/CBS</span>
    </div>
  </button>
</mat-menu>
